var chopstickChart = function() {

    var _dataGlobal = {
        labels: ["Paid by Partena", "Paid by you"],
        datasets: [{
            data: [1307.41, 145.26],
            backgroundColor: [
                "#FFCE56",
                "#FF6384"
            ],
            hoverBorderColor: [
                "#529ee0",
                "#529ee0"
            ],
            hoverBackgroundColor: [
                "#FFCE56",
                "#FF6384"
            ]
        }]
    };

    var _dataPersonal = {
        labels: ["Paid by Partena", "Paid by you"],
        datasets: [{
            data: [81.36, 29.45],
            backgroundColor: [
                "#FFCE56",
                "#FF6384"
            ],
            hoverBorderColor: [
                "#529ee0",
                "#529ee0"
            ],
            hoverBackgroundColor: [
                "#FFCE56",
                "#FF6384"
            ]
        }]
    };

    var _options = {
        cutoutPercentage: 50,
        animateRotate: true,
        legend: {
            display: true,
            position: "bottom",
            fontSize: 13
        }
    }

    var _canvasGlobal = $("#js-expenses");
    var _canvasPersonal = $("#js-expenses-personal")

    if (_canvasGlobal.length > 0) {
        var chartGlobalExpenses = new Chart(_canvasGlobal, {
            type: 'doughnut',
            data: _dataGlobal,
            options: _options
        });
    }

    if (_canvasPersonal.length > 0) {
        var chartPersonalExpenses = new Chart(_canvasPersonal, {
            type: 'doughnut',
            data: _dataPersonal,
            options: _options
        });
    }
};
